import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { AppReducer } from './app/app.ts';
import { AuthReducer } from './auth/auth.ts';
import { FeatureFlagsReducer } from './featureFlags/featureFlags.ts';
import { InsuranceClearanceCertificateReducer } from './insuranceClearanceCertificate/insuranceClearanceCertificate.ts';
import { InsuranceHistorySummaryReducer } from './insuranceHistorySummary/insuranceHistorySummary.ts';
import { pushNotificationsListener } from './listeners/pushNotifications.listener.ts';
import { MainMenuReducer } from './mainMenu/mainMenu.ts';
import { PollingReducer } from './polling/polling.ts';
import { SummaryReducer } from './summary/summary.ts';
import { UIReducer } from './ui/ui.ts';
import { ViewportReducer } from './viewport/viewport.ts';

const rootReducer = combineReducers({
  app: AppReducer,
  auth: AuthReducer,
  ui: UIReducer,
  summary: SummaryReducer,
  mainMenu: MainMenuReducer,
  viewport: ViewportReducer,
  featureFlags: FeatureFlagsReducer,
  polling: PollingReducer,
  insuranceCertificate: InsuranceClearanceCertificateReducer,
  insuranceHistorySummary: InsuranceHistorySummaryReducer
});

const resettableRootReducer = (state: ReturnType<typeof rootReducer> | undefined, action: { type: string }) => {
  if (action.type === 'auth/logout') {
    state = undefined;
  }
  return rootReducer(state, action);
};

export const store = configureStore({
  reducer: resettableRootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true
    }).prepend(pushNotificationsListener.middleware),
  devTools: !import.meta.env.PROD
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
